import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-icon_status_paused",
  "use": "svg-icon-icon_status_paused-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-icon_status_paused\"><path d=\"M9 13V3h4v10H9zm-6 0V3h4v10H3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol